import { QueryCache } from '@tanstack/vue-query';
import { useGlobalEventEmitter } from '@/shared/composables';
import { Errors } from '@/shared/constants';
import { hasField } from '@/shared/utils/objects';

const queryCache = new QueryCache({
  onError: (error: unknown) => {
    const responseFailed
      = error
        && hasField(error, 'response')
        && hasField(error.response, 'status')
        && Number(error.response.status) >= 500;

    const isTimeout = error && hasField(error, 'code') && error.code === 'ECONNABORTED';

    if (responseFailed || isTimeout) {
      const eventEmitter = useGlobalEventEmitter();
      eventEmitter.emit(Errors.NETWORK_ERROR, error);
    }
  },
});

export const tanstackOptions = {
  queryClientConfig: {
    queryCache,
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  },
};
